import React from 'react';
import { motion } from 'framer-motion';
import { Eye } from 'lucide-react';
import { visualResources } from '../data/benefits';
export function VisualSystem() {
  return <section className="py-24 px-4 bg-stone-50" data-id="element-291" data-mp="9uwi6a6d2s4q">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-292" data-mp="9w7l67rzfvus">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-rose-700/10 text-rose-700 mb-5" data-id="element-293" data-mp="3na2jl48070lq">
          <Eye size={26} aria-hidden="true" data-id="element-294" data-mp="3s1klbuhup57r" />
        </div>
        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-stone-800" data-id="element-295" data-mp="2ul5396ncrdvm">
          Completely Visual From Start to Finish
        </h2>
        <p className="text-lg text-stone-600 mb-2" data-id="element-296" data-mp="2zix4wsdsued0">
          This is not a text-heavy teaching manual.
        </p>
        <p className="text-2xl font-serif font-bold text-rose-900 mb-10" data-id="element-297" data-mp="2p0rehx178n0g">
          Makeup is visual. Your teaching material should be visual too.
        </p>

        <div className="bg-white p-6 md:p-8 rounded-2xl border border-stone-200" data-id="element-298" data-mp="2fapt5d08dip8">
          <p className="text-sm font-semibold uppercase tracking-wider text-rose-800 mb-5" data-id="element-299" data-mp="2aco9apuzdfcp">
            Inside, you'll find:
          </p>
          <ul className="flex flex-wrap justify-center gap-2" data-id="element-300" data-mp="26bktu4guhlc0">
            {visualResources.map(item => <li key={item} className="bg-stone-100 border border-stone-200 text-stone-800 text-sm rounded-full px-3 py-1.5" data-id="element-301" data-mp="21a5bwl9yruxu">
                {item}
              </li>)}
          </ul>
        </div>

        <p className="text-xl mt-8 text-stone-800" data-id="element-302" data-mp="3qr6bbe366dfs">
          Your students can see what you mean — not just hear you explain it.
        </p>
      </motion.div>
    </section>;
}